





























































import { Component, Prop, Vue } from "vue-property-decorator";
import EventActions from "@/components/Event/EventActions.vue";
import { mapGetters } from "vuex";

@Component({
  components: { EventActions },
  computed: { ...mapGetters(["isLoggedIn"]) }
})
export default class EventDetails extends Vue {
  @Prop() event!: Event;
  @Prop() small?: boolean;
  @Prop() history!: boolean;
  dialog = false;
  selected = "";
}
